class PhotosState {
  static initial() {
    return new PhotosState({
      backwardPhoto: null,
      currentPhoto: null,
      forwardPhoto: null,
      loading: false,
      error: false,
    })
  }

  constructor({ backwardPhoto, currentPhoto, forwardPhoto, loading, error }) {
    this.backwardPhoto = backwardPhoto
    this.currentPhoto = currentPhoto
    this.forwardPhoto = forwardPhoto
    this.loading = loading
    this.error = error
  }

  copyWith({ backwardPhoto, currentPhoto, forwardPhoto, loading, error }) {
    return new PhotosState({
      backwardPhoto: backwardPhoto !== undefined ? backwardPhoto : this.backwardPhoto,
      currentPhoto: currentPhoto !== undefined ? currentPhoto : this.currentPhoto,
      forwardPhoto: forwardPhoto !== undefined ? forwardPhoto : this.forwardPhoto,
      loading: loading !== undefined ? loading : this.loading,
      error: error !== undefined ? error : this.error,
    })
  }

  equals(state) {
    return (
      this.backwardPhoto === state.backwardPhoto &&
      this.currentPhoto === state.currentPhoto &&
      this.forwardPhoto === state.forwardPhoto &&
      this.loading === state.loading &&
      this.error === state.error
    )
  }
}

export default PhotosState
